import { FC } from 'react';
import { Chip, Icon } from '@kontentino/ui';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons/faCircleCheck';
import { useApprovalsCount } from 'app/modules/approvals/hooks/useApprovalsCount';

export const ApprovalsIcon: FC = () => {
  const { totalCount } = useApprovalsCount();

  return (
    <div className="tw-relative">
      <Icon icon={faCircleCheck} className="!tw-flex" size={20} />
      {totalCount > 0 && (
        <div className="tw-absolute -tw-top-3 tw-left-1">
          <Chip variant="alert">{totalCount}</Chip>
        </div>
      )}
    </div>
  );
};
